import * as actionTypes from '../actionTypes';

export const initShifts = shifts => ({ type: actionTypes.shifts.INIT, shifts });
export const setShift = shift => ({ type: actionTypes.shifts.SET, shift });
export const setShifts = shifts => ({ type: actionTypes.shifts.SET_SHIFTS, shifts });